import { useGridContext } from '../../../../../../../_grid/contexts/gridContext';
import { useUISettings } from '../../../../../../../../../context/network/http/QueryProvider/queries/UISettings';
import { GridCell } from '../../../../../../../../../api/generated/data-contracts';
import { useFixedCellValue } from '../../../../../../../_grid/hooks/useFixedCellValue';
import { memo } from 'react';
import { useCategoryResourceAllocationBackground } from '../../../../hooks/useCategoryResourceAllocationBackground';

export const CategoryWithAllocationColoredTotalCell = memo(function CategoryWithAllocationColoredTotalCell({
    cell,
    isRowExpanded,
}: {
    cell: GridCell;
    isRowExpanded: boolean;
}) {
    const {
        data: {
            settings: {
                resourcePlannerSettings: {
                    gridSettings: {
                        //
                        heatMapTextColor,
                    },
                },
            },
        },
    } = useUISettings();

    const { useGridCellValue } = useGridContext();
    const stateValue = useGridCellValue(cell);
    const value = useFixedCellValue(stateValue);
    const backgroundColor = useCategoryResourceAllocationBackground();
    return (
        <div
            style={{
                //
                backgroundImage: backgroundColor,
                height: '100%',
                width: '100%',
                ...(isRowExpanded && {
                    width: 80,
                    height: 32,
                }),
                transition: 'all .3s ease',
                position: 'relative',
                cursor: 'pointer',
            }}
        >
            <span
                style={{
                    position: 'absolute',
                    top: '50%',
                    ...(isRowExpanded
                        ? {
                              transform: 'translate(-100%, -50%)',
                              left: 'calc(100% - 8px)',
                          }
                        : {
                              transform: 'translate(-50%, -50%)',
                              left: '50%',
                          }),
                    transition: '.3s',
                    color: heatMapTextColor,
                    gap: 5,
                    display: 'flex',
                }}
            >
                {value}
            </span>
        </div>
    );
});


